import { Entity } from '../entity';
import { UUID } from '../uuid/entity';

export interface TechniqueMitigationProps {
    id: string;
    mitigationId: string;
    description: string;
    techniqueId: string;
    srcId?: string;
}

export class TechniqueMitigation extends Entity {
    description: string;
    mitigationId: string;
    techniqueId: string;
    srcId?: string;

    constructor({
        id,
        mitigationId,
        techniqueId,
        description,
        srcId,
    }: TechniqueMitigationProps) {
        super({ id });
        this.description = description;
        this.mitigationId = mitigationId;
        this.srcId = srcId;
        this.techniqueId = techniqueId;
    }

    static new({
        mitigationId,
        description,
        techniqueId,
        srcId,
    }: Omit<TechniqueMitigationProps, 'id'>): TechniqueMitigation {
        const uuid = new UUID();
        return new TechniqueMitigation({
            id: uuid.toString(),
            mitigationId,
            description,
            srcId,
            techniqueId,
        });
    }
}
